/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
enum SlugPrefix {
  ChdTv = '/chd-tv/',
  ChdTvBrowseAll = '/chd-tv/browse-all/',
  ChdTvEvents = '/chd-tv/events/',
  ChdTvThePeopleStudy = '/chd-tv/the-peoples-study',
  ChdTvVideos = '/chd-tv/videos/',
  ChdTvShows = '/chd-tv/shows/',
  ChdTvTextAlerts = '/chd-tv/get-alerts/',
}

export default SlugPrefix;
